import { getListProjectDocumentsQueryOptions, getListProjectPersonsQueryOptions } from '@amarantos/api-client'
import { createFileRoute } from '@tanstack/react-router'
import { RouteErrorFallback } from '@/components/route-error-fallback'
import { ProjectDocumentsPanel } from '@/features/projects/components/project-documents-panel'
import { listAllProjectAssetsParams } from '@/features/projects/utils/project-asset-list'
import { projectAssetDialogSearchSchema } from '@/features/projects/utils/search'

export const Route = createFileRoute('/_authenticated/projects/$projectId/documents')({
	validateSearch: projectAssetDialogSearchSchema,
	loader: ({ context: { queryClient }, params: { projectId } }) => {
		queryClient.ensureQueryData(getListProjectDocumentsQueryOptions(projectId, listAllProjectAssetsParams))
		queryClient.ensureQueryData(getListProjectPersonsQueryOptions(projectId, listAllProjectAssetsParams))
	},
	errorComponent: ({ error, reset }) => (
		<RouteErrorFallback error={error} reset={reset} fallbackMessageKey='error.load_project_documents' />
	),
	component: ProjectDocumentsRoute,
})

function ProjectDocumentsRoute() {
	const { projectId } = Route.useParams()
	const search = Route.useSearch()
	const navigate = Route.useNavigate()

	// Dialog state lives in the URL, so the create/edit dialogs are deep-linkable.
	const closeDialog = () => {
		navigate({ search: (previous) => ({ ...previous, dialog: undefined, assetId: undefined }) })
	}

	return (
		<ProjectDocumentsPanel
			projectId={projectId}
			dialog={search.dialog}
			selectedId={search.assetId}
			onCreate={() => navigate({ search: (previous) => ({ ...previous, dialog: 'create' as const }) })}
			onEdit={(document) =>
				navigate({ search: (previous) => ({ ...previous, assetId: document.id, dialog: 'edit' as const }) })
			}
			onClose={closeDialog}
		/>
	)
}
